import type { MapData, MapEdge, MapNode } from '../models/map.type';

type aStarNode = {
  node: MapNode;
  // id: number,
  parent?: aStarNode;
  g?: number;
  h?: number;
  f?: number;
};

export function AStarPathBetweenNodes(node1: MapNode, node2: MapNode, map: MapData) {
  let openList: Array<aStarNode> = [];
  let closedList: Array<aStarNode> = [];
  let path: Array<aStarNode> = [];

  let currentNode: aStarNode = { node: node1 };
  let endNode: aStarNode = { node: node2 };

  openList.push(currentNode);

  while (openList.length > 0) {
    // get node with lowest f cost
    currentNode = openList[0];
    for (let i = 0; i < openList.length; i++) {
      // f is assigned for every node put on the open list; default so the
      // comparison stays total for the start node, which has none yet.
      if ((openList[i].f ?? 0) < (currentNode.f ?? 0)) {
        currentNode = openList[i];
      }
    }

    // remove current node from open list
    openList = openList.filter((node) => {
      return node.node.id != currentNode.node.id;
    });

    // add current node to closed list
    closedList.push(currentNode);

    // check if current node is the end node
    if (currentNode.node.id == endNode.node.id) {
      endNode.parent = currentNode.parent;
      // console.log('found path');
      break;
    }

    // get edges
    let nodeEdges = map.edges.filter((edge: MapEdge) => {
      return edge.from == currentNode.node.id || edge.to == currentNode.node.id;
    });

    // loop through edges
    nodeEdges.forEach((edge: MapEdge) => {
      let nextNodeId = edge.to == currentNode.node.id ? edge.from : edge.to;
      const foundNode = map.nodes.find((node: MapNode) => {
        return node.id == nextNodeId;
      });
      // An edge always names nodes that exist in the same map.
      if (!foundNode) {
        return;
      }
      let nextNode: aStarNode = { node: foundNode };

      // check if node is in closed list
      if (
        closedList.find((node) => {
          return node.node.id == nextNode.node.id;
        })
      ) {
        return;
      }

      // check if node is in open list
      if (
        openList.find((node) => {
          return node.node.id == nextNode.node.id;
        })
      ) {
        return;
      }

      // add node to open list
      openList.push(nextNode);

      // set parent node
      nextNode.parent = currentNode;

      // calculate g cost
      nextNode.g = (currentNode.g || 0) + 1;

      // calculate h cost
      nextNode.h = 0.5; //Math.abs(nextNode.x - endNode.x) + Math.abs(nextNode.y - endNode.y);

      // calculate f cost
      nextNode.f = nextNode.g + nextNode.h;
    });
  }

  // create path
  currentNode = endNode;
  while (currentNode.parent) {
    path.push(currentNode);
    currentNode = currentNode.parent;
  }
  path.push(currentNode);

  return path;
}
